const IS_PRODUCTION = process.env.REACT_APP_DEPLOY_ENV !== "staging"

export const plans = [
  {
    id: "plan_Sa5me",
    name: "Free",
    description: "Get started with our ad-supported free plan",
    amount: 0,
    is_featured: false,
    interval: "monthly",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 4 goals",
      "Get a personal action plan"
    ],
    non_features: [
      "Asset allocation advice",
      "Ad-free experience",
      "Live onboarding and check-ins with personal financial coach"
    ],
    is_payment_required: false,
    channel_id: "fd2cef25-e2b9-4783-bc1a-60d85e74d13c",
    is_exclusive: false,
    is_offered: false
  },
  {
    id: "plan_13acH",
    name: "Free",
    description: "Get started with our ad-supported free plan",
    amount: 0,
    is_featured: false,
    interval: "monthly",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 2 goals",
      "Get a personal action plan"
    ],
    non_features: [
      "Asset allocation advice",
      "Ad-free experience",
      "Live onboarding and check-ins with personal financial coach"
    ],
    is_payment_required: false,
    channel_id: "fd2cef25-e2b9-4783-bc1a-60d85e74d13c",
    is_exclusive: false,
    is_offered: false
  },
  {
    id: "plan_ACEgf",
    name: "Employer-Sponsored",
    description: "Become your own financial action hero",
    amount: 0,
    is_featured: false,
    interval: "monthly",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 6 goals",
      "Get a personal action plan",
      "Asset allocation advice"
    ],
    non_features: [],
    is_payment_required: true,
    channel_id: "ebebc617-dfdc-4ac7-8f39-99b12f1b0cca",
    is_exclusive: true,
    is_offered: false
  },
  {
    id: "plan_bH3E9",
    name: "Basic",
    description: "Become your own financial action hero",
    amount: 5,
    free_trial_days: 0,
    is_featured: false,
    interval: "monthly",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 2 goals",
      "Get a personal action plan"
    ],
    non_features: [
      "Asset allocation advice",
      "Ad-free experience",
      "Live onboarding and check-ins with personal financial coach"
    ],
    is_payment_required: true,
    channel_id: "cd2c4a32-00c1-450e-91bb-112c97e725b4",
    is_exclusive: false,
    is_offered: IS_PRODUCTION
  },
  {
    id: "plan_h1By3",
    name: "Premium",
    description: "Become your own financial action hero",
    amount: 9,
    free_trial_days: 30,
    is_featured: true,
    interval: "monthly",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 6 goals",
      "Get a personal action plan",
      "Asset allocation advice",
      "Ad-free experience"
    ],
    non_features: [
      "Live onboarding and check-ins with personal financial coach"
    ],
    is_payment_required: true,
    channel_id: "cd2c4a32-00c1-450e-91bb-112c97e725b4",
    is_exclusive: false,
    is_offered: IS_PRODUCTION
  },
  {
    id: "plan_p0RQI",
    name: "Premium",
    description: "Become your own financial action hero",
    amount: 99,
    is_featured: true,
    interval: "yearly",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 6 goals",
      "Get a personal action plan",
      "Asset allocation advice",
      "Ad-free experience"
    ],
    non_features: [
      "Live onboarding and check-ins with personal financial coach"
    ],
    is_payment_required: true,
    channel_id: "cd2c4a32-00c1-450e-91bb-112c97e725b4",
    is_exclusive: false,
    is_offered: false
  },
  {
    id: "plan_m0acH",
    name: "Personal",
    description: "Human coach offers guidance through SAVVI",
    amount: 29,
    is_featured: false,
    interval: "monthly",
    features: [
      "All the features of Premium",
      "Initial onboarding call with your personal financial coach",
      "Quarterly check-in calls to review progress with your financial plan",
      "Up to 30 minutes per month of additional phone-based coaching",
      "Unlimited technical assistance with SAVVI planning tool"
    ],
    non_features: [],
    is_payment_required: true,
    channel_id: "cd2c4a32-00c1-450e-91bb-112c97e725b4",
    is_exclusive: false,
    is_offered: IS_PRODUCTION
  },
  {
    id: "plan_b85D3",
    name: "Voluntary Benefit",
    description: "Get started with your new financial wellness benefit",
    amount: "BenefitsPlace",
    is_featured: false,
    interval: null,
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 8 goals",
      "Get a personal action plan",
      "Asset allocation advice"
    ],
    non_features: [],
    is_payment_required: false,
    channel_id: "a19d022d-88df-4409-ad64-b6b3fdecc75b",
    is_exclusive: true,
    is_offered: false
  },
  {
    id: "plan_COVID",
    name: "COVID Relief Planning",
    description: "Get free help weather the storm",
    amount: 0,
    is_featured: false,
    interval: "30 days",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 2 goals",
      "Get a personal action plan",
      "COVID-related hardship planning"
    ],
    non_features: [],
    is_payment_required: false,
    channel_id: "c55caefa-2061-4685-8f31-f6e9c01db6e0",
    is_exclusive: true,
    is_offered: false
  },
  {
    id: "plan_VYCVD",
    name: "COVID Relief Planning",
    description: "Get free help weather the storm",
    amount: 0,
    is_featured: false,
    interval: "90 days",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 2 goals",
      "Get a personal action plan",
      "COVID-related hardship planning"
    ],
    non_features: [],
    is_payment_required: false,
    channel_id: "1aa2c15c-7971-4e1e-b336-50506cd3e329",
    is_exclusive: true,
    is_offered: false
  },
  {
    id: "plan_ba237",
    name: "Premium",
    description: "Become your own financial action hero",
    amount: 5,
    free_trial_days: 0,
    is_featured: true,
    interval: "monthly",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 6 goals",
      "Get a personal action plan",
      "Asset allocation advice",
      "Ad-free experience"
    ],
    non_features: [],
    is_payment_required: true,
    channel_id: "73818a87-2017-4741-8e3a-a298f60d51b2",
    is_exclusive: true,
    is_offered: false
  },
  {
    id: "plan_be238",
    name: "Premium",
    description: "Become your own financial action hero",
    amount: 5,
    free_trial_days: 0,
    is_featured: true,
    interval: "monthly",
    features: [
      "Track your accounts",
      "Understand your money",
      "Plan for up to 6 goals",
      "Get a personal action plan",
      "Asset allocation advice",
      "Ad-free experience"
    ],
    non_features: [],
    is_payment_required: true,
    channel_id: "73818a87-2017-4741-8e3a-a298f60d51b2",
    is_exclusive: true,
    is_offered: false
  }
]
